export default () => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect x="1.875" y="5" width="2.25" height="14" rx="1.125" fill="#367BF5" />
		<rect x="19.875" y="5" width="2.25" height="14" rx="1.125" fill="#367BF5" />
		<rect x="7.875" y="5" width="2.25" height="14" rx="1.125" fill="#367BF5" />
		<rect x="13.875" y="5" width="2.25" height="14" rx="1.125" fill="#367BF5" />
	</svg>
);
